/**
 * Created by dushyantha on 7/12/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewSchedule.controller:crewScheduleCtrl
     *
     * @description
     *
     */
    angular
        .module('crewSchedule')
        .controller('crewScheduleCtrl', crewScheduleCtrl);

    function crewScheduleCtrl(CommonMasterData,CommonLogicService, crewScheduleService, MessageService, EventManagerService, $scope, $stateParams, StorageServices,TabService,CrewingSelectionHelper,
                              PopupManager, CrewingHelper,CrewingAdaptor,crewingConstants, applicationConstants,crewSchAssignTraningModel,crewSchAssignTraningLogic, hotkeys, ApplicationService,RemoteService, DateUtilService) {
        var vm = this;
        vm.view = 'CREW_SCHEDULE';
        vm.isLoadCrewList = false;
        vm.model = {
        	crewTypes: [],
        	baseTypes: [],
          employerHubs:[],
            crewList:[],
            showSearchPanel:false,
            actualScheduleSearchParam:{},
            publishScheduleSearchParam:{},
            searchDetails: {
                fromDate :'',
                toDate : '',
                crewBase:{airPortCode:''},
                crewType:{crewType:''},
                employerHub: {hubCode:''},
                days:'',
                crewDetails:'',
                crewID:'',
                fleetExperince:'',
                hubCode:''

            },
            crewActualSchedule:[],
            crewPublishDetails:{},
            crewPublishSchedule:[],
            crewDTO:[],
            crewDTOs:[],
            alertsDTO:[],
            memoDTO:[],
            weekDays:[],
            scheduleType:'actual',
            airportExclusion:{},
            crewExclusion:[],
            crewNotes:[],
            noteButtonLabel:'ADD',
            blockDetails:{},
            timeZoneText:'',
            isSchedulePublish:false,
            isNoteAvailable:false,
            showEditorPanel:true,
            nextPrevCrew : null,
            status : false,
            airportList:[],
            trainingBlocks : [],
            fdpPendingBlocks: [],
            warnings: []
        };

        /**
         * DTO definition noteModelDTO
         */
        vm.noteModelDTO =function(){
           var noteModel={};
            noteModel.crewProfileId="";
            noteModel.fromDate="";
            noteModel.toDate="";
            noteModel.remark="";
            noteModel.crewSchdNoteId = null;
            noteModel.version = null;
            noteModel.createdBy = null;
            return noteModel
        };

        vm.noteModel = vm.noteModelDTO();

        hotkeys.add({
            combo: 'ctrl+z',
            description: 'Undo operation',
            callback: function(event, hotkey) {
                onFireUndoEvent();
            }
        });

        //Events
        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VIEW_MODE_CHANGE, changeViewMode);
        EventManagerService.registerEventListener(EventManagerService.EVENT.CREWING.OPEN_MEMO, openMemoListener);
        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.REFRESH, refreshPage);
        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SHOW_IN_CREW_PORTAL, onShowInCrewPortal);
        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.HIDE_IN_CREW_PORTAL, onHideInCrewPortal);
        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SHOW_VIOLATIONS, onShowViolationReasons);
        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.SHOW_IN_PORTAL, showInCrewPortalListener);
        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.UNDO, onFireUndoEvent);


        /**
        * Handle navigation from Crewing Screen
        * @param crewId
        **/

        if (!!$stateParams.crewId) {
            var tabLocalData = StorageServices.getTabData('crewSchedule');
            if (!!tabLocalData && !!tabLocalData.crewingParams) {
                vm.model.searchDetails = tabLocalData.crewingParams;
                vm.model.searchDetails.fromDate = tabLocalData.crewingParams.fromDate.replace(/\-/g,'/');
                vm.model.searchDetails.toDate = tabLocalData.crewingParams.toDate.replace(/\-/g,'/');
                vm.model.searchDetails.crewID = tabLocalData.crewingParams.crewId;
                vm.model.searchDetails.crewBase={airPortCode:tabLocalData.crewingParams.crewBase};
                vm.model.searchDetails.fleetExperince = tabLocalData.crewingParams.fleetExperince;
                vm.model.searchDetails.crewType={crewTypeCode:''};
                vm.model.actualScheduleSearchParam = crewScheduleService.adaptStateParams(vm.model.searchDetails);
                vm.model.crewList = tabLocalData.crewingParams.crewIdCol;
                vm.isLoadCrewList =true;
                loadActualSchedule(false, undefined, 'Y');
            }
        }

        /**
         * set search panel init data
         **/

        vm.getSearchPanelData = function () {
            loadCrewBaseList();
            loadCrewTypes();
            loadEmployerHubs();
            vm.model.showSearchPanel = !vm.model.showSearchPanel;
            //vm.model.weekDays = moment.weekdaysShort(true);
        };


        function onShowInCrewPortal() {
            hideOnCrewPortal(false);
        }

        function onHideInCrewPortal() {
            hideOnCrewPortal(true);
        }

        function onShowViolationReasons() {
            var selection = CrewingSelectionHelper.getSelectedBlocks();
            var details = {};
            details.crewProfileID = selection[0].events[0].crewInfo.crewProfileId;
            details.pairingID = selection[0].patternId;
            PopupManager.openModal('SHOW_IN_VIOLATIONS', details, function(){});
        }

        function showInCrewPortalListener() {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                vm.isBlockViewFlagEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                if(vm.isBlockViewFlagEnable){
                    if(!!vm.fullRoster.schedule){
                        if(vm.model.isSchedulePublish){
                            var message = MessageService.MESSAGES.CREWING.SHOW_ALL_IN_CREW_PORTAL;
                            var details = {
                                title: 'Confirmation',
                                messages: [message],
                                allCrew: 'DONT_SHOW'
                            };
                            PopupManager.openModal('CONFIRM_SHOW_IN_PORTAL', details, showPortalForAllConfirm);
                        }else{
                            MessageService.warning(MessageService.MESSAGES.CREWING.CREW_SCHEDULE_NOT_PUBLISHED);
                        }
                    }else{
                        MessageService.warning(MessageService.MESSAGES.CREWING.CREW_SCHEDULE_NOT_LOADED);
                    }

                }
            });

            function showPortalForAllConfirm(pass){
                var selected=[];
                if(angular.isUndefined(pass)){
                    return false;
                }else{
                    if(pass.allCrew){
                        var tCrew = {crewDTO:vm.model.crewDTO};
                        selected = [tCrew];
                        CrewingHelper.updateVisibilityFlagCrews(selected, vm.model.searchDetails, function(){
                        	loadActualSchedule(true, undefined, 'Y');
                        });
                    }
                }
            }
        }

        function hideOnCrewPortal(visibilityFlag) {

            var selection = CrewingSelectionHelper.getSelectedBlocks();

            var ignoreRest = function(events){
                return _.filter(events, function (event) {
                    if(event.type!=='REST'){
                        return event;
                    }
                });
            };

            var blocks = selection.reduce(function (flattern,block) {
                return (!!block.events)? flattern.concat(ignoreRest(block.events)) : flattern;
            },[]);

            var crewIds = blocks.map(function (block) {
                return block.crewInfo.crewId;
            });

            CrewingHelper.updateBlockVisibilityFlag(blocks,visibilityFlag, function (response) {
            	loadActualSchedule(false, undefined, 'Y');
                MessageService.success('Crew Portal Visibility flags successfully updated');

                var dutyChangeNotification = !!response && !!response.crewScheduleChangeDutyNotificationList
                    && response.crewScheduleChangeDutyNotificationList[0];

                if (!!dutyChangeNotification && dutyChangeNotification.sendCrewNotification) {
                    var param = {};
                    param.message = dutyChangeNotification.message;
                    param.profileId = dutyChangeNotification.crewProfileId;
                    param.user = dutyChangeNotification.user;
                    param.telephone = dutyChangeNotification.telephone;
                    param.crewSchdChangeId = dutyChangeNotification.crewSchdChangeId;
                    if (dutyChangeNotification.disableSendYes) {
                        param.disableSendYes = "false";
                    }
                    else {
                        param.disableSendYes = "true";
                    }
                    param.pushNotificationMessage = dutyChangeNotification.pushNotificationMessage;
                    PopupManager.openModal('SEND_CHANGE_NOTIFICATION', param);
                }
            });
        }

        function loadCrewBaseList(){
            CommonMasterData.getCrewBaseList(
                function (crewBase) {
                    vm.model.baseTypes = crewBase;
                }, function () {

                }
            );
        }

        function loadCrewTypes(){
            CommonMasterData.getCrewTypeList(
                function (crewTypes) {
                    vm.model.crewTypes = crewTypes;
                },
                function () {
                    console.log('Crew type retrieval error');
                }
            );
        }

        function loadEmployerHubs(){
            CommonMasterData.getEmployerHubList(
              function (employerHubs){
                vm.model.employerHubs=employerHubs;
              },
              function (){
                console.log('Employer Hub retrieval error');
              }
            )
        }

        function loadCrewList(crewType, hubCode){

            var load = function () {
                var param={};
                param.crewType = crewType;
                param.active = true;
                param.crewBase=vm.model.searchDetails.crewBase.airPortCode;
                param.fleetExperince=vm.model.searchDetails.fleetExperince;
                param.startDate = vm.model.searchDetails.fromDate;
                param.endDate = vm.model.searchDetails.toDate;
                param.hubCode = hubCode ? hubCode : "";

                CommonMasterData.loadCrewList(param,
                    function (response) {
                        vm.model.crewList = crewScheduleService.adaptCrewList(response);
                    },
                    function () {
                        console.log('Crew list retrieval error');
                    }
                );
            };

            //always loading the crewlist
            load();
        }

        vm.loadCrewListByType = function(crewType, hubCode){
            vm.model.searchDetails.fleetExperince='';
            loadCrewList(crewType, hubCode);
        };

        vm.searchCrewSchedule = function(searchDetails){
            clearStateParam();
            vm.model.searchDetails = searchDetails;
           vm.model.searchDetails.fleetExperince='';
           vm.model.actualScheduleSearchParam = crewScheduleService.adaptActualScheduleSearchParam(vm.model.searchDetails);
           vm.isLoadCrewList =true;
           loadActualSchedule(true, undefined, 'Y');
           //vm.model.publishScheduleSearchParam = crewScheduleService.adaptPublishScheduleSearchParam(vm.model.searchDetails);
        };

        function clearStateParam(){
            $stateParams.crewId = null;
        }

        function refreshPage(){
        	loadActualSchedule(true);
        }

        function getTrackingTimeZone() {
            CrewingHelper.getTimeZoneText(
                function (timeZoneResponse) {
                    vm.model.timeZoneText = timeZoneResponse.message;
                },
                function (error) {
                    console.log(error);
                }
            );
        }

        function isCrewSchedulePublishedForCrewProfileId() {
            CrewingHelper.checkIsPublishedByCrewProfileId(
                [vm.model.crewDTO.crewProfileId],
                vm.model.searchDetails.fromDate,
                vm.model.searchDetails.toDate,
                function (isPublished) {
                    vm.model.isSchedulePublish =isPublished;
                    crewScheduleService.setIsPublished(isPublished);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.IS_CREW_SCHEDULE_PUBLISHED, isPublished);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function loadWarnings() {
          const searchParams  = vm.model.searchDetails;
          const toDate = DateUtilService.getLastDateOfMonth(searchParams.toDate);
          let fromDate = null;
          let tenantCode = null;

          const loginInfo = JSON.parse(localStorage.getItem('ALC.login_info'));

          if (loginInfo !== null) {
              tenantCode = loginInfo.tenantCode;
          }

          if (tenantCode === '3O') {
            fromDate = DateUtilService.getYearStartDate(toDate);
          } else {
            fromDate = DateUtilService.get12MonthsEarlierDate(toDate);
          }

          const requestParam = {
            fromDate: fromDate,
            toDate: toDate,
            crewId: searchParams.crewID
          };

          crewScheduleService.getLimitationWarnings(
            requestParam,
            function(response) {
              if(response.warningLimit !== null && response.warningLimit > 0 && response.flyingHours > response.warningLimit) {
                const msg = getWarningMessage(response);
                vm.model.warnings = [msg];
              } else {
                vm.model.warnings = [];
              }
            },
            function (error) {
              MessageService.error(error);
            }
          );

          function getWarningMessage(response) {
            const limit = response.warningLimit;
            const hours = response.flyingHours;

            return 'Alert!!! Flying Hours Limitation - ' + hours;
          }
        }

        function searchFlyingHours() {
          CrewingHelper.searchFlyingHours(
            vm.model.actualScheduleSearchParam.crewIds,
            vm.model.searchDetails.fromDate,
            vm.model.searchDetails.toDate,
            function (data) {
              var totalFlyingHours = 0;
              data.forEach(function (item) {
                totalFlyingHours += item.flyingHoursInMinutes;
              });
              const updatedModel = angular.copy(vm.model);
              console.log("searchFlyingHours updatedModel :", updatedModel)
              updatedModel.crewDTO.flyingDuration = getHours(totalFlyingHours);
              vm.model = updatedModel;
            },
            function (error) {
              MessageService.error(error);
            }
          );
      }

        function loadTrainingStages() {
          var crewProfileId = vm.model.crewDTO.crewProfileId;
          var toDate = vm.model.searchDetails.toDate;

          var details = {};
          CrewingHelper.getTrainingStagesDetails(crewProfileId, toDate,
            function(response) {
              details.currentStage = response.currentStage;
              details.crewTrainingStageDTOList = response.crewTrainingStageDTOList;
              details.crewTrainingStageViolatedSectorList = response.crewTrainingStageViolatedSectorList;
              vm.model.trainingStageDetails = details;
              vm.model.crewDTO.currentStage = response.currentStage;
              vm.model.crewDTO.applicableForCrew = response.applicableForCrew;
            },
            function(error) {
              MessageService.error(error);
            });
        }

        function loadActualSchedule(showLoading, afterUpdateCallBack, isRefreshSidePanel){
            vm.model.weekDays = moment.weekdaysShort(true);
            crewScheduleService.searchCrewSchedule(vm.model.actualScheduleSearchParam,showLoading,
                function (response) {
                    $scope.$broadcast('prevNextMonthClick', vm.model.actualScheduleSearchParam);
                    $scope.$broadcast('onBlockDetailsChange');

                    const updatedModel = angular.copy(vm.model);
                    updatedModel.showSearchPanel = false;
                    vm.fullRoster = CrewingAdaptor.searchCrewScheduleAdaptor(response, vm.model.actualScheduleSearchParam);
                    //updatedModel.crewActualSchedule= crewScheduleService.adaptSchedule(response.crewScheduleDTOs[0].rosterDutyDTOs,response.crewDTO);
                    updatedModel.status = response.crewScheduleDTOs[0].crewDTO.active;
                    updatedModel.crewDTO = response.crewScheduleDTOs[0].crewDTO;
                    updatedModel.crewDTOs = [];
                    updatedModel.crewDTOs.push(response.crewScheduleDTOs[0].crewDTO);
                    updatedModel.crewDTO.crewExpiryDTOs = crewScheduleService.adaptExpiry(updatedModel.crewDTO.crewExpiryDTOs, vm.model.actualScheduleSearchParam);
                    updatedModel.alertsDTO = response.crewScheduleDTOs[0].alertsDTOs;
                    updatedModel.memoDTO = response.crewScheduleDTOs[0].memoDTOs;

                    updatedModel.publishScheduleSearchParam.fromDate = vm.model.searchDetails.fromDate;
                    updatedModel.publishScheduleSearchParam.toDate = vm.model.searchDetails.toDate;
                    updatedModel.publishScheduleSearchParam.crewId = response.crewScheduleDTOs[0].crewDTO.crewId;
                    updatedModel.publishScheduleSearchParam.crewProfileId = response.crewScheduleDTOs[0].crewDTO.crewProfileId;

                    updatedModel.searchDetails.crewID = response.crewScheduleDTOs[0].crewDTO.crewId;

                    updatedModel.nextPrevCrew = response.nextPrevCrewInfo;
                    vm.model = updatedModel;

                    crewSchAssignTraningModel.setCrewInfo(vm.model.crewDTO);

                    CrewingHelper.setCrewScheduleData(vm.fullRoster);
                    // loadPublishSchedule();
                    loadUseImgUrl();
                    loadCrewAirportsExclusion();
                    loadCrewExclusion();
                    searchCrewNote();
                    getTrackingTimeZone();
                    isCrewSchedulePublishedForCrewProfileId();
                    searchFlyingHours();
                    loadTrainingStages();
                    loadFdpPendingCrewSchedules();
                    loadWarnings();
                    loadWarnings();
                    if(!vm.isLoadCrewList){
                        loadCrewList(vm.model.crewDTO.crewTypeCode);
                    }
                    crewSchAssignTraningLogic.loadTrainingsForLastRequest();
                    if(!angular.isUndefined(afterUpdateCallBack)){
                        afterUpdateCallBack();
                    }
                    if(!!isRefreshSidePanel && isRefreshSidePanel == 'Y'){
                    	vm.model.blockDetails = {};
                    }

                  StorageServices.clearTabData('crewSchedule');
                },
                function (error) {
                    MessageService.error(error[0]);
                }
            );
        }

        function loadFdpPendingCrewSchedules() {
          const reqBody = {
            crewId: vm.model.searchDetails.crewID,
            fromDate: vm.model.searchDetails.fromDate,
            toDate: vm.model.searchDetails.toDate
          };
          crewScheduleService.getFdpPendingCrewSchedules(reqBody,
            function (response) {
              vm.model.fdpPendingBlocks = response;
            },
            function (error) {
              MessageService.error("Failed to load FDP pending blocks!");
            }
          );
        }

        function loadPublishSchedule(){
            //vm.model.scheduleType= 'publish';
            //EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_SCHEDULE.TYPE_CHANGE);

            if(!!vm.model.publishScheduleSearchParam.fromDate){
                crewScheduleService.searchCrewPublishSchedule(vm.model.publishScheduleSearchParam,
                    function (response) {
                        const updatedModel = angular.copy(vm.model);
                        updatedModel.crewPublishDetails = response;
                        updatedModel.crewPublishSchedule= response.publishedDuties;
                        vm.model = updatedModel;
                    },
                    function (error) {
                        MessageService.error(error[0]);
                    }
                );
            }

        }

        function changeViewMode(data) {
            loadPublishSchedule();
            vm.model.scheduleType = data.mode;
        }

        function loadUseImgUrl(){
            crewScheduleService.loadCrewImageURL(vm.model.crewDTO.crewProfileId,
                function (response) {
                    vm.model.crewDTO.imageUrl= response;
                },
                function (error) {
                }
            );
        }

        function loadCrewAirportsExclusion(){
            crewScheduleService.loadCrewAirportsExclusion(vm.model.crewDTO.crewProfileId,
                function (response) {
                  vm.model.airportExclusion= adaptAirportExclusion(response);
                },
                function (error) {
                }
            );
        }

      function adaptAirportExclusion(airportExclusion) {
        var list = [];
        angular.forEach(airportExclusion,function (airport) {
                list.push(airport.airportCode);
          });
        return list;
        }

        function loadCrewExclusion(){
            var param={};
            param.crewProfId = vm.model.crewDTO.crewProfileId;
            crewScheduleService.loadCrewExclusion(param,
                function (response) {
                  vm.model.crewExclusion = adaptCrewExclusion(response);
                },
                function (error) {
                }
            );
        }

      function adaptCrewExclusion(crewExclusion) {
          var list = [];
          angular.forEach(crewExclusion,function (crew) {
                  list.push({
                      crewId : crew.crewId,
                      crewName : crew.crewName
                  });
            });
          return list;
        }

        function searchCrewNote(){
            var param={};
            param.crewProfileId = vm.model.crewDTO.crewProfileId;
            param.fromDate= vm.model.searchDetails.fromDate;
            param.toDate= vm.model.searchDetails.toDate;
            crewScheduleService.searchCrewNote(param,
                function (response) {
                    const updatedModel = angular.copy(vm.model);
                    if(!!response && response.length){
                        updatedModel.isNoteAvailable=true;
                    }
                    updatedModel.crewNotes = response;
                    vm.model = updatedModel;
                },
                function (error) {
                }
            );
        }

        vm.addEditCrewScheduleNotes = function(){
            vm.noteModel.crewProfileId = vm.model.crewDTO.crewProfileId;
            crewScheduleService.addEditNotes(vm.noteModel,
                function (response) {
                    if(response.success){

                        if(!!vm.noteModel.crewSchdNoteId){
                            MessageService.success(MessageService.MESSAGES.CREW_SCHEDULE.EDIT_NOTE_SUCCESS);
                        }
                        else{
                            MessageService.success(MessageService.MESSAGES.CREW_SCHEDULE.ADD_NOTE_SUCCESS);
                        }
                        searchCrewNote();
                        vm.noteModel = vm.noteModelDTO();
                        vm.model.noteButtonLabel='ADD'
                    }


                },
                function (error) {
                    MessageService.error(error[0]);
                }
            );
        };

        vm.loadEditNoteData = function(noteModel){
            vm.model.noteButtonLabel='EDIT';
            vm.noteModel = noteModel;
        };

        vm.deleteCrewNotes = function(note){
            var param ={};
            param.crewSchdNoteId=note.crewSchdNoteId;
            param.version= note.version;
            if(vm.model.status){
              crewScheduleService.deleteCrewNotes(param,
                function (response) {
                  MessageService.success(MessageService.MESSAGES.CREW_SCHEDULE.DELETE_NOTE_SUCCESS);
                  searchCrewNote();
                  vm.noteModel = vm.noteModelDTO();
                },
                function (error) {
                  MessageService.error(error[0]);
                }
              );
            } else MessageService.warning(MessageService.MESSAGES.CREWING.INACTIVE_CREW_WARNING);

        };

        vm.monthNavigation= function(type){
            var monthStart , monthEnd,monthStartDate;
            if(type === 'Next'){
                monthStartDate = moment(vm.model.actualScheduleSearchParam.fromDate, "DD/MM/YYYY").add(1, 'month');
                //monthEnd = moment(vm.model.actualScheduleSearchParam.toDate, "DD/MM/YYYY").add(1, 'month').format("DD/MM/YYYY");
            }
            else{
                var preMonthStart , prevMonthEnd;
                monthStartDate = moment(vm.model.actualScheduleSearchParam.fromDate, "DD/MM/YYYY").subtract(1, 'month');
                //monthEnd = moment(vm.model.actualScheduleSearchParam.toDate, "DD/MM/YYYY").subtract(1, 'month').format("DD/MM/YYYY");
            }
            var month = monthStartDate.format('MM');
            var year = monthStartDate.format('YYYY');
            //monthStart = monthStartDate.format("DD/MM/YYYY");
            //monthStart = moment([year, month]).add(-1,"month").format("DD/MM/YYYY");
            monthStart = '01/'+month+'/'+year;
            var monthEndDate = moment(monthStart, "DD/MM/YYYY").endOf('month');
            monthEnd = monthEndDate.format("DD/MM/YYYY");

            vm.model.searchDetails.fromDate = monthStart;
            vm.model.searchDetails.toDate = monthEnd;
            vm.model.actualScheduleSearchParam.fromDate = monthStart;
            vm.model.actualScheduleSearchParam.toDate = monthEnd;
            loadActualSchedule(true, undefined, 'Y');

        };

        vm.crewNavigation = function(type){

        	var nextOptionCrewId = null;

        	if(type === 'Next'){
            	if(!!vm.model.nextPrevCrew && !!vm.model.nextPrevCrew.nextCrewId){
            		nextOptionCrewId  =  vm.model.nextPrevCrew.nextCrewId;
            	}
            }
            else{
            	if(!!vm.model.nextPrevCrew && !!vm.model.nextPrevCrew.prewCrewId){
            		nextOptionCrewId  =  vm.model.nextPrevCrew.prewCrewId;
            	}

            }
            vm.model.actualScheduleSearchParam.crewIds = nextOptionCrewId;
            vm.model.searchDetails;
            loadActualSchedule(true, undefined, 'Y');
        };

        function openMemoListener(memo) {
            var param = {};
            param.day = memo.memoDate;
            param.crewProfileId = vm.model.crewDTO.crewProfileId;
            param.crewId = vm.model.crewDTO.crewId;
            param.memo = memo;
            param.readOnly = (memo.memoCategoryCode=='RECENCY')?true:false;
            param.status = vm.model.status;
            param.batch = vm.model.crewDTO.crewBatch;
            param.group  = vm.model.crewDTO.crewGroup;
            PopupManager.openModal('ADD_EDIT_MEMO', param, onAddMemoClose);
        }

        function onAddMemoClose(param) {
          if(param){
            createLocalStorageVariable(param.crewId);
            loadActualSchedule(false, undefined, 'Y');
          }
        }

        vm.onAddMemo = function (params) {
            var param = {};
            param.day = params.date;
            param.crewProfileId = vm.model.crewDTO.crewProfileId;
            param.crewId = vm.model.crewDTO.crewId;
            param.status = vm.model.status;

           // param.memo = CrewingHelper.getMemoForDayAndCrew(param.crewId, param.day);
            PopupManager.openModal('ADD_EDIT_MEMO', param, onAddMemoClose);
        };

        vm.onEditBlock = function (params) {

               getBlockDetail(params);

        };

        vm.onAssignEvent = function (params) {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                var param = {};
                param.day = params.day[0];
                param.crew = params.crew[0];
                param.container = params.container;
                param.showInCrewPortalParams = {
                    isVisible: appParamsEnable,
                    isEnabled: appParamsEnable && vm.model.isSchedulePublish,
                    value: !vm.model.isSchedulePublish ? false : true
                };
                addEditEvent(param);
            });
        };

      function updateSelectedCrew(ids) {
            updateCrewInSearchParams(ids);
            loadActualSchedule(false, undefined, 'Y');
        }

        function updateCrewInSearchParams(crewIds) {
            vm.model.actualScheduleSearchParam.crewIds = crewIds[0];
        }

      vm.onClickDelayedReportTiming = function (params) {
        PopupManager.openModal('DELAYED_REPORT_TIMING', params,onDelayedReportTimingClose);
      }


      function onDelayedReportTimingClose() {
        loadActualSchedule(false, undefined, 'Y');
      }

      vm.onSbyCallout = function (params,setPopUpSizeWhenSBYCallOut) {
        sbyCallOutPopup(params,setPopUpSizeWhenSBYCallOut)

      }

      function sbyCallOutPopup(params,setPopUpSizeWhenSBYCallOut) {
        var details = {
          title: 'SBY Call Out Notice',
          date:null,
          time:null,
          error:'Date Time Cannot Be Empty'
        };

        PopupManager.openModal('SBY_CALL_OUT', details, function (action) {
          handleSBYPopupAction(action, params,setPopUpSizeWhenSBYCallOut);
        });

      }

      function handleSBYPopupAction(action,params,setPopUpSizeWhenSBYCallOut) {
        if(action==='YES'){
          params.sbyCallOutDateTime=CrewingHelper.getSbyCallOutDateTime();
          setPopUpSizeWhenSBYCallOut();
          vm.onAssignPairing(params);
        }
      }

        vm.onAssignPairing = function (params) {
             console.log("params :", params)
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                params.day = params.day[0];
                params.crew = params.crew[0];
                params.flyingDuration = vm.model.crewDTO.flyingDuration;
                params.targetDuration = vm.model.crewDTO.targetDuration;
                params.showInCrewPortalParams = {
                    isVisible: appParamsEnable,
                    isEnabled: appParamsEnable && vm.model.isSchedulePublish,
                    value: !vm.model.isSchedulePublish ? false : true
                };
                params.showTargetHoursPopup = true;
                PopupManager.openModalInDiv(params.container, 'ASSIGN_PARING', params, onCloseAssignPairingModal);

                function onCloseAssignPairingModal(assignParingResponse) {
                    assignPairingResponseActions(assignParingResponse);
                }
            });
        };


 		vm.onReplacePairing = function (params) {
          console.log("params :", params)
          CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
            var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
            params.crewDTOs = vm.model.crewDTOs;
            params.showInCrewPortalParams = {
              isVisible: appParamsEnable,
              isEnabled: appParamsEnable && vm.model.isSchedulePublish,
              value: !vm.model.isSchedulePublish ? false : true
            };
            CrewingHelper.searchFlyingMinutes({searchDTOS : [{patternId : params.duty.patternId, crewProfileId : params.crew.crewDTO.crewProfileId}]},
                function(response) {
                    params.deletingDutyflyingMins = response.map[params.duty.patternId];
                },
                function(error) {
                    console.log(error);
                }
            );
            console.log("params :", params)
            PopupManager.openModalInDiv(params.container, 'REPLACE_PARING', params, onCloseReplacePairingModal);

            function onCloseReplacePairingModal(assignParingResponse) {
              assignPairingResponseActions(assignParingResponse);
            }
          });
        };

        vm.onAssignTraining = function (params) {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                params.day = params.day[0];
                params.crew = params.crew[0];
                params.showInCrewPortalParams = {
                    isVisible: appParamsEnable,
                    isEnabled: appParamsEnable && vm.model.isSchedulePublish,
                    value: !vm.model.isSchedulePublish ? false : true
                };

                PopupManager.openModalInDiv(params.container, 'ASSIGN_TRAINING', params, onAssignTrainingClose);

                function onAssignTrainingClose(updatedCredIds) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                    if (!!updatedCredIds && updatedCredIds.length > 0) {
                        //updateSelectedCrew(updatedCredIds);
                    	createLocalStorageVariable(updatedCredIds[0]);
                        loadActualSchedule(false, undefined, 'Y');
                    }
                }
            });

        };

        function addEditEvent(param) {
            PopupManager.openModalInDiv(param.container, 'ASSIGN_EVENT', param, onAssignEventClose);

            function onAssignEventClose(params) {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                if (!!params && !!params.assignEventResponse) {
                    if (params.assignEventResponse.success) {
                       // updateSelectedCrew([params.assignEventRequestParam.crewId]);
                        loadActualSchedule(false, undefined, 'Y');
                        createLocalStorageVariable(params.assignEventRequestParam.crewId);

                        if(params.isEditMode){
                        	MessageService.success(MessageService.MESSAGES.CREWING.UPDATE_SUCCESS);
                        }else{
                        	MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);
                        }
                      if(params.assignEventResponse.sendCrewNotification === "Y"){
                        var param ={};
                        param.message=params.assignEventResponse.message;
                        param.profileId= params.assignEventResponse.crewProfileId;
                        param.user = params.assignEventResponse.user;
                        param.telephone = params.assignEventResponse.telephone;
                        param.crewSchdChangeId = params.assignEventResponse.crewSchdChangeId;
                        if (params.assignEventResponse.disableSendYes) {
                          param.disableSendYes = "false";
                        }
                        else {
                          param.disableSendYes = "true";
                        }
                        param.pushNotificationMessage=params.assignEventResponse.pushNotificationMessage;
                        PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                      }
                    } else if (!!params.assignEventResponse.adaptedRegulationMap) {
                        var regulationDetailParam = {
                            regulationMap: params.assignEventResponse.adaptedRegulationMap,
                            onAcceptPassBackParam: params,
                            isRestrictedForAssigningIllegalDuties: params.assignEventResponse.restrictedForAssigningIllegalDuties,
                            isRestrictedOperation :  params.assignEventResponse.restrictedOperation
                        };
                        PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForEvents);
                    }
                }
            }
            function onCloseRegulationPopupForEvents(params) {
                if (!!params) {
                    var isContinueIllegal = false;
                    var isUserConfirm = true;
                    var violatedList = getOverridenViolations(params.assignEventResponse.regulationMap);
                    CrewingHelper.assignEditEvent(params.assignEventRequestParam, isContinueIllegal, isUserConfirm,params.dutyChangeReason,params.dutyChangeComment, violatedList,
                        function (assignEventData) {
                            if (assignEventData.success) {
                              loadActualSchedule(false, undefined, 'Y');
                              createLocalStorageVariable(params.assignEventRequestParam.crewId);
                              MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);
                              // updateSelectedCrew([params.assignEventRequestParam.crewId]);

                              if (assignEventData.overlapped === "Y") {
                                var details = {
                                  title: 'Duty Overlapping',
                                  messages: [MessageService.MESSAGES.CREWING.DUTY_OVERLAPPING]
                                };
                                EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                                PopupManager.openModal('CONFIRM_OVERLAP', details, confirmReplacingPattern);

                                function confirmReplacingPattern(param) {
                                  if (param === "SWAP") {
                                    CrewingHelper.replacePatternWithOverlapped(
                                      assignEventData.overlappedDuties,
                                      null,
                                      assignEventData.crewProfileId,
                                      assignEventData.crewSchdChangeId,
                                      function (response) {
                                        if (response != null) {
                                          loadActualSchedule(false, undefined, 'Y');
                                        }
                                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.RESET_SELECTED_CREW_AND_DAYS);
                                        if (assignEventData.sendCrewNotification === "Y") {
                                          var param = {};
                                          param.message = assignEventData.message;
                                          param.profileId = assignEventData.crewProfileId;
                                          param.user = assignEventData.user;
                                          param.telephone = assignEventData.telephone;
                                          param.crewSchdChangeId = assignEventData.crewSchdChangeId;
                                          if (assignEventData.disableSendYes) {
                                            param.disableSendYes = "false";
                                          }
                                          else {
                                            param.disableSendYes = "true";
                                          }
                                          param.pushNotificationMessage=assignEventData.pushNotificationMessage;
                                          param.dutyChangeReason = params.dutyChangeReason;
                                          PopupManager.openModal('SEND_CHANGE_NOTIFICATION', param);
                                        }
                                      },
                                      function (msg) {

                                      });
                                  } else {
                                    if (assignEventData.sendCrewNotification === "Y") {
                                      var param = {};
                                      param.message = assignEventData.message;
                                      param.profileId = assignEventData.crewProfileId;
                                      param.user = assignEventData.user;
                                      param.telephone = assignEventData.telephone;
                                      param.crewSchdChangeId = assignEventData.crewSchdChangeId;
                                      if (assignEventData.disableSendYes) {
                                        param.disableSendYes = "false";
                                      }
                                      else {
                                        param.disableSendYes = "true";
                                      }
                                      param.pushNotificationMessage=assignEventData.pushNotificationMessage;
                                      param.dutyChangeReason = params.dutyChangeReason;
                                      PopupManager.openModal('SEND_CHANGE_NOTIFICATION', param);
                                    }
                                  }
                                }
                              }
                              else if(assignEventData.sendCrewNotification === "Y"){
                                var param ={};
                                param.message=assignEventData.message;
                                param.profileId= assignEventData.crewProfileId;
                                param.user = assignEventData.user;
                                param.telephone = assignEventData.telephone;
                                param.crewSchdChangeId = assignEventData.crewSchdChangeId;
                                if (assignEventData.disableSendYes) {
                                  param.disableSendYes = "false";
                                }
                                else {
                                  param.disableSendYes = "true";
                                }
                                param.pushNotificationMessage=assignEventData.pushNotificationMessage;
                                param.dutyChangeReason = params.dutyChangeReason;
                                PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                              }
                            }


                        },
                        function (msg) {
                            MessageService.error(msg);
                        }
                    );
                }
            }
        }

        function blockDetailResponseActions(blockDetails) {
            switch (blockDetails.blockType) {
                case  'FLIGHT' :
                {
                    blockDetails.openBlockDetails = true;
                    blockDetails.openBlockDetailsPanel = true;
                    //SlideInPanelService.openPanel('crewing.right.panel', blockDetails);
                    break;
                }
                case 'TRAINING' :
                {
                    blockDetails.isTraining = true;
                    blockDetails.openBlockDetailsPanel = true;
                    // SlideInPanelService.openPanel('crewing.right.panel', blockDetails);
                    break;
                }
                case 'EVENT' :
                {
                    var param = {
                        day: '',
                        crew: blockDetails.crew,
                        isEditMode: true,
                        eventDetails: blockDetails,
                        container: blockDetails.container
                    };
                    addEditEvent(param);
                    break;
                }
            }
        }

        function getBlockDetail(param) {
            CrewingHelper.getBlockDetailForCrewSchedule(
                param.duty.blockId,
                param.duty.crewScheduleBlockId,
                !!param.duty.patternId,
                function (blockDetails) {
                    const updatedModel = angular.copy(vm.model);
                    updatedModel.blockDetails = blockDetails;
                    vm.model = updatedModel;
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL.DATA_CHANGED,'test');
                    blockDetails.isTraining = false;
                    blockDetails.crewScheduleBlockId = param.duty.crewScheduleBlockId;
                    blockDetails.patternId = param.duty.patternId;
                    blockDetails.crewProfileId = vm.model.crewDTO.crewProfileId;
                    blockDetails.container = param.container;
                    blockDetails.crew = param.crew;

                    blockDetailResponseActions(blockDetails);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

		function handleUpdateCrewRequirement(action) {
			console.log(action, vm.model.isComplementFilled);
			vm.model.isComplementFilled = true;
			console.log(vm.model.isComplementFilled);
			if (action === "save") {
				deleteBlock(vm.model.selectedBlocks, vm.model.isCheckGenderWarnings);
			}
		}

		function acknowledgeDuty(searchParam) {
      CrewingHelper.acknowledgeDuty(searchParam,
        function(response) {
          console.log(response);
          MessageService.success(MessageService.MESSAGES.CREWING.DUTY_ACKNOWLEDGE_SUCCESS);
        },
        function(error) {
          console.log(error);
          MessageService.error(MessageService.MESSAGES.CREWING.DUTY_ACKNOWLEDGE_FAILED);
        }
      );
    }


        function deleteBlock(blocks, isCheckGenderWarnings) {

			vm.model.selectedBlocks = blocks;
            //ignore check when multiple blocks selected
            if (!!isCheckGenderWarnings && CrewingHelper.isDistributionCheckApplicable(blocks[0].patternType)) {
                CrewingHelper.checkDistributionWarnings(blocks[0].crewInfo.crewTypeMasterCode, blocks[0].blockId, blocks[0].crewInfo.crewProfileId, true, deleteBlock, blocks);
            } else {

				if(angular.isUndefined(vm.model.isComplementFilled)){
					blocks["isComplementFilled"] = false;
					vm.model.isComplementFilled = false;
				}else{
					blocks["isComplementFilled"] = vm.model.isComplementFilled;
				}
        var UnAssignBlockRequestCrewDTOs = [];
        for(var i=0; i < blocks.length; i++) {
          for(var j=0; j < vm.model.crewDTOs.length; j++) {
            var crewProfileId = vm.model.crewDTOs[j].crewProfileId;
            var crewExists = checkIfCrewExists(crewProfileId, UnAssignBlockRequestCrewDTOs);
            if(blocks[i].crewInfo.crewProfileId == vm.model.crewDTOs[j].crewProfileId && !crewExists){
              UnAssignBlockRequestCrewDTOs.push(vm.model.crewDTOs[j]);
            }
          }
        }
				CrewingHelper.unAssignBlock(blocks,UnAssignBlockRequestCrewDTOs,
					function(data) {
						console.log(data);
						console.log("vm.model.isComplementFilled", vm.model.isComplementFilled);



						if (data.crewComplementNeedChange === true && data.pairingId && vm.model.isComplementFilled === false) {
							console.log("inside if");
							var newParams = {};
							newParams.patternId = data.pairingId;



							RemoteService.getCrewRequirementsByPairingId(data.pairingId).then(
								function(response) {
									console.log(response);
									newParams.requiredList = response;
									PopupManager.openModal('VIEW_CONFIRM_PAIRING_MODAL', newParams, handleUpdateCrewRequirement);
								},
								function(msg) {
									console.log("error : ", msg);
									MessageService.error(msg);
								}
							);
						}



						if (vm.model.isComplementFilled === true || data.crewComplementNeedChange === false || data.pairingId === null) {
							// updateSelectedCrew(getCrewIdsFromBlocks(blocks));
							//getOpenPairings(vm.model.openPairingParam, true);
							loadActualSchedule(false, undefined, 'Y');
							EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.RESET_SELECTED_CREW_AND_DAYS);
							createLocalStorageVariable(blocks[0].crewInfo.crewId);
							MessageService.success(MessageService.MESSAGES.CREWING.DUTY_REMOVE_SUCCESS);
							if (data.otherHubSyncResponsesCSBMap && Object.keys(data.otherHubSyncResponsesCSBMap).length > 0){
                getSyncResponses(data.otherHubSyncResponsesCSBMap);
              }
							vm.model.isComplementFilled = false;
              if(data.sendCrewNotification){
                var param ={};
                param.message=data.message;
                param.profileId= data.crewProfileId;
                param.user = data.user;
                param.telephone = data.telephone;
                param.crewSchdChangeId = data.crewSchdChangeId;
                if (data.disableSendYes) {
                  param.disableSendYes = "false";
                }
                else {
                  param.disableSendYes = "true";
                }
                param.pushNotificationMessage=data.pushNotificationMessage;
                PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
              }
						}
					},
					function() {
						MessageService.error(MessageService.MESSAGES.CREWING.DUTY_REMOVE_FAILED);
					}
				);


            }
        }
        function getSyncResponses(data){
          var result = {};
          for (var csbID in data) {
              if (data.hasOwnProperty(csbID)) {
                  var CSB = data[csbID];

                  for (var tenant in CSB) {
                      if (CSB.hasOwnProperty(tenant)) {
                          if (!result.hasOwnProperty(tenant)) {
                              result[tenant] = true;
                          }
                          result[tenant] = result[tenant] && CSB[tenant];
                      }
                  }
              }
          }
          var syncResponses = [];
          for (var key in result) {
            if (result.hasOwnProperty(key)) {

                if (result[key]) {
                  MessageService.success('Tenant: ' + key + ', Status: SUCCESS');
                } else {
                  MessageService.warning('Tenant: ' + key + ', Status: FAILED');
                }

            }
          }
          return syncResponses;
        }

        function createLocalStorageVariable(data){
        	localStorage.setItem("crewList", data);
        }
        function checkIfCrewExists(crewProfileId, crewArray) {
          for (var i = 0; i < crewArray.length; i++) {
            if (crewArray[i].crewProfileId === crewProfileId) {
              return true;
            }
          }
          return false;
        }

      vm.assignDirectEvent = function (param, eventType) {
            var stDate, endDate;
            if (param.isMultiple) {
                stDate = param.startDate;
                endDate = param.endDate;
            } else {
                stDate = endDate = param.dateClicked;
            }
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                if(appParamsEnable && vm.model.isSchedulePublish){
                    var details = {
                        title: 'Confirmation',
                        messages: [MessageService.MESSAGES.CREWING.CREW_PORTAL_HIDE],
                        close : 'CLOSE'
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignDirectAction);
                }else{
                    confirmAssignDirectAction('NO');
                }
            });

            function confirmAssignDirectAction(pass) {

            	if(pass == 'CLOSE'){
            		return;
            	}

                var isShowInCrewPortal = true;
                if (pass == 'YES') {
                    isShowInCrewPortal = false;
                }

              if (param.isOnProbation == 'Y') {
                var details = {
                  title: 'Confirmation',
                  messages: [MessageService.MESSAGES.CREWING.CREW_PROBATION_OVERRIDE,
                    "Crew Details:",
                    "Id:" + param.crewId,
                    "Name: " + param.crewName],
                  close: 'CLOSE'
                };
                PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignDirectAction);
              } else {
                confirmAssignDirectAction('NO');
                // vm.onDirectAction({ param: crewInfo, type: crewingConstants.EVENT_TYPES.sickLeave });
              }

              function confirmAssignDirectAction(pass) {
                if (pass == 'CLOSE' || pass == undefined) {
                  return;
                }
                var forceAssignLeave = false;
                if (pass == 'YES') {
                  forceAssignLeave = true;
                }

                CrewingHelper.assignDirectEvent(
                    param.crewProfileId,
                    eventType,
                    stDate,
                    endDate,
                    false,
                    isShowInCrewPortal,
                    function (data) {
                        if (data.success) {
                            loadActualSchedule(false, undefined, 'Y');
                            handleSuccessMessage(eventType,param.crewId)
                            //updateSelectedCrew([param.crewId]);
                            loadActualSchedule(false, undefined, 'Y');
                        }
                        else if (!!data.regulationMap) {
                          var data1= CrewingAdaptor.assignEventAdaptor(data)
                          var regulationDetailParam = {
                            regulationMap: data1.adaptedRegulationMap,
                            onAcceptPassBackParam: data1
                          };
                          console.log("Show regulations",regulationDetailParam)
                          PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForDirectEvents);
                        }
                      function onCloseRegulationPopupForDirectEvents(data) {
                        if (!!data) {
                          // var isContinueIllegal = false;
                          var isUserConfirm = true;
                          // while(data.selectedDates[0] !== data.regulationOccuredDate ){
                          //   data.assignEventRequestParam.selectedDates.shift();
                          // }
                          CrewingHelper.assignDirectEvent(
                            param.crewProfileId,
                            eventType,
                            stDate,
                            endDate,
                            false,
                            isShowInCrewPortal,
                            function (data) {
                              if (data.success) {
                                loadActualSchedule(false, undefined, 'Y');
                                handleSuccessMessage(eventType,crewId)
                                //updateSelectedCrew([param.crewId]);
                                loadActualSchedule(false, undefined, 'Y');
                              }
                            },
                            function (msg) {
                              MessageService.error(msg);
                            },
                            param.isCustomSelectedDates,
                            param.customSelectedDates,
                            forceAssignLeave,
                            isUserConfirm,
                          param.selectedBase
                          );
                        }
                      }
                    },
                    function (error) {
                        MessageService.error(error);
                    },
                    param.isCustomSelectedDates,
                  param.customSelectedDates,
                  forceAssignLeave,
                  false,
                  param.selectedBase
                );
            }
            }
        };
      function handleSuccessMessage(eventType, crewId) {
        var messageMap = {};

        messageMap[crewingConstants.EVENT_TYPES.blockDays] = MessageService.MESSAGES.CREWING.ASSIGN_BLOCK_DAYS_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.off] = MessageService.MESSAGES.CREWING.ASSIGN_OFF_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.vulvLeave] = MessageService.MESSAGES.CREWING.ASSIGN_VULV_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.sickLeave] = MessageService.MESSAGES.CREWING.ASSIGN_SICK_LEAVE_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.annualLeave] = MessageService.MESSAGES.CREWING.ASSIGN_ANNUAL_LEAVE_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.cnt] = MessageService.MESSAGES.CREWING.ASSIGN_CNT_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.officeDuty] = MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.secondedinOtherHubs] = MessageService.MESSAGES.CREWING.ASSIGN_SOH_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.cabinSpecialDuty] = MessageService.MESSAGES.CREWING.ASSIGN_CSD_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.cabinSupportActivity] = MessageService.MESSAGES.CREWING.ASSIGN_CSA_SUCCESS;
        messageMap[crewingConstants.EVENT_TYPES.available] = MessageService.MESSAGES.CREWING.ASSIGN_AVL_SUCCESS;

        if (messageMap.hasOwnProperty(eventType)) {
          createLocalStorageVariable(crewId);
          MessageService.success(messageMap[eventType]);
        } else {
          console.log('Unhandled event type: ' + eventType);
        }
      }
        vm.onBlockDelete = function (blocks) {
            deleteBlock(blocks, true);
        };

        vm.onAcknowledgeDuty = function (param) {
          console.log("onAcknowledgeDuty =====", param)
          acknowledgeDuty(param);
        };

        function assignPairingResponseActions(assignParingResponse) {
            if (!!assignParingResponse) {
                if (!!assignParingResponse.regulationDetails.regulationMap) {
                  var regulationDetailParam = {
                    regulationMap: assignParingResponse.regulationDetails.adaptedRegulationMap,
                    onAcceptPassBackParam: assignParingResponse,
                    isShowCrewPortal: assignParingResponse.isShowCrewPortal,
                    isAirportRecencyOverridden: assignParingResponse.isAirportRecencyOverridden,
                    isRestrictedForAssigningIllegalDuties:assignParingResponse.isRestrictedForAssigningIllegalDuties,
                    isRestrictedOperation : assignParingResponse.isRestrictedOperation
                  };
                  PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForPairing);
                }
                else {
                  //var crewId = CrewingHelper.getCrewIdFromCrewProfileID(assignParingResponse.crewProfileId, vm.model.crewSchedule.nameCollection);
                  // updateSelectedCrew([crewId]);
                  createLocalStorageVariable(vm.model.crewDTO.crewId);
                  loadActualSchedule(false, undefined, 'Y');
                  MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_SUCCESS);
                  if (assignParingResponse.otherBlockIllegal) {
                    MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
                  }
                  var data = assignParingResponse.regulationDetails;
                  if(data.sendCrewNotification === "Y"){
                    var params ={};
                    params.message=data.message;
                    params.profileId= data.crewProfileId;
                    params.user = data.user;
                    params.telephone = data.telephone;
                    params.crewSchdChangeId = data.crewSchdChangeId;
                    if (data.disableSendYes) {
                      params.disableSendYes = "false";
                    }
                    else {
                      params.disableSendYes = "true";
                    }
                    params.pushNotificationMessage=data.pushNotificationMessage;
                    params.dutyChangeReason = assignParingResponse.dutyChangeReason;
                    PopupManager.openModal('SEND_CHANGE_NOTIFICATION',params);
                  }
                  EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                }

              EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
              } else {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
              }


            function onCloseRegulationPopupForPairing(params) {
                if (!!params) {
                  // filter violated regulations
                  var violatedList = getOverridenViolations(params.regulationDetails.regulationMap);
                	createLocalStorageVariable(vm.model.crewDTO.crewId);
                    CrewingHelper.assignPattern(
                        params.crewProfileId,
                        params.pattern,
                        params.isRequest,
                        params.isCallFromDayOff,
                        params.isObsFlight,
                        params.isHideinCrewPortal,
                        false,
                        true,
                        params.isShowCrewPortal,
                        params.crewScheduleBlockId,
                        params.isComplementFilled,
                        params.isTargetHoursValid,
                        params.sbyCallOutDateTime,
                        params.isAirportRecencyOverridden,
                        params.dutyChangeReason,
                        params.dutyChangeComment,
                        violatedList,
                        function (data) {
                            MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_SUCCESS);
                            if (data.otherBlockIllegal) {
                                MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
                            }
                            if (!!data) {

                                    loadActualSchedule(false, undefined, 'Y');
                                    //updateSelectedCrew([crew.crewId]);
                                   // updateSelectedParing(params.pattern, crew.crewTypeCode);

                            }

                          if (data.overlapped === "Y") {

                            var details = {
                              title: 'Duty Overlapping',
                              messages: [MessageService.MESSAGES.CREWING.DUTY_OVERLAPPING]
                            };
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                            PopupManager.openModal('CONFIRM_OVERLAP', details, confirmReplacingPattern);

                            function confirmReplacingPattern(param) {
                              if (param === "SWAP") {
                                CrewingHelper.replacePatternWithOverlapped(
                                  data.overlappedDuties,
                                  params.pattern.patternId,
                                  data.crewProfileId,
                                  data.crewSchdChangeId,
                                  function (response) {
                                    if (response != null) {
                                    loadActualSchedule(false, undefined, 'Y');
                                    }
                                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.RESET_SELECTED_CREW_AND_DAYS);
                                    if(data.sendCrewNotification === "Y"){
                                      var param ={};
                                      param.message=data.message;
                                      param.profileId= data.crewProfileId;
                                      param.user = data.user;
                                      param.telephone = data.telephone;
                                      param.crewSchdChangeId = data.crewSchdChangeId;
                                      if (data.disableSendYes) {
                                        param.disableSendYes = "false";
                                      }
                                      else {
                                        param.disableSendYes = "true";
                                      }
                                      param.pushNotificationMessage=data.pushNotificationMessage;
                                      param.dutyChangeReason = params.dutyChangeReason;
                                      PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                                    }
                                  },
                                  function (msg) {

                                  });
                              }
                              else {
                                if(data.sendCrewNotification === "Y"){
                                  var param ={};
                                  param.message=data.message;
                                  param.profileId= data.crewProfileId;
                                  param.user = data.user;
                                  param.telephone = data.telephone;
                                  param.crewSchdChangeId = data.crewSchdChangeId;
                                  if (data.disableSendYes) {
                                    param.disableSendYes = "false";
                                  }
                                  else {
                                    param.disableSendYes = "true";
                                  }
                                  param.pushNotificationMessage=data.pushNotificationMessage;
                                  param.dutyChangeReason = params.dutyChangeReason;
                                  PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                                }
                              }
                            }
                          }
                          else {
                            if(data.sendCrewNotification === "Y"){
                              var param ={};
                              param.message=data.message;
                              param.profileId= data.crewProfileId;
                              param.user = data.user;
                              param.telephone = data.telephone;
                              param.crewSchdChangeId = data.crewSchdChangeId;
                              if (data.disableSendYes) {
                                param.disableSendYes = "false";
                              }
                              else {
                                param.disableSendYes = "true";
                              }
                              param.pushNotificationMessage=data.pushNotificationMessage;
                              param.dutyChangeReason = params.dutyChangeReason;
                              PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                            }
                          }

                          EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                        },
                        function (msg) {
                            MessageService.error(msg);
                        }
                    );
                } else {
                    //repositionSelectedOpenParing(assignParingResponse.pattern);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                }
            }


        }

        function getOverridenViolations(regulationsMap) {
          var violatedRegulations = [];

          angular.forEach(regulationsMap, function(value, key) {
            console.log(key, value);
            angular.forEach(value, function (regulation) {
              if (!regulation.legalDay1 || !regulation.legalDay2) {
                violatedRegulations.push(regulation.regulationCode);
              }
            });
          });

          return violatedRegulations;
        }

        vm.onEmailCrewSchedule = function (params) {
            var crewProfileId = params.crews.crewDTO.crewProfileId;
            CrewingHelper.emailCrewSchedule(
                crewProfileId,
                vm.model.searchDetails.fromDate,
                vm.model.searchDetails.toDate,
                function (date) {
                    if (date) {
                        MessageService.success(MessageService.MESSAGES.CREWING.SCHEDULE_EMAIL_SUCCESS);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        function onSendAlertClose(crewId) {
            if (!!crewId) {
            	createLocalStorageVariable(crewId);
                loadActualSchedule(false, undefined, 'Y');
            }
        }

      function onEvaluateTrainingsClose(crewId) {
        if (!!crewId) {
          createLocalStorageVariable(vm.model.crewDTO.crewId);
          loadActualSchedule(false, undefined, 'Y');
        }
      }

        function onSendSmsClose(crewId) {
            if (!!crewId) {
            	createLocalStorageVariable(vm.model.crewDTO.crewId);
                loadActualSchedule(false, undefined, 'Y');
            }
        }

        /*vm.onSendSms = function (param) {
            param.messageContent = CrewingHelper.getDutiesForCrew(param.crew.crewId, param.day.date, 3, null);
            PopupManager.openModal('SMS', param, onSendSmsClose);
        };*/


        vm.onEvaluateTrainings = function (param) {

          CrewingHelper.getBlockDetailTrainings(param.blockInfo,
            true,
            function (blockDetails) {
              vm.model.trainingBlocks = blockDetails;
              console.log(JSON.stringify(vm.model.trainingBlocks));
              PopupManager.openModal('EVALUATE_TRAININGS', vm.model.trainingBlocks, onEvaluateTrainingsClose);
            },
            function (error) {
              MessageService.error(error);
            }
          );

        };

        vm.onSendSms = function (param) {
        	if(param.isForDay) {
        		param.messageContent = CrewingHelper.getDutiesForCrew(param.crew.crewId, param.day.date, 3, null);
        	} else {
    			param.messageContent = CrewingHelper.getDutiesForCrew(param.crewInfo.crewId, param.checkInDate, 2, param.crewScheduleBlockId);
        	}
            PopupManager.openModal('SMS', param, onSendSmsClose);
        };

        vm.onSendAlert = function (param) {

            if(vm.model.isSchedulePublish){
                PopupManager.openModal('ALERT', param, onSendAlertClose);
            }
            else{
                MessageService.warning(MessageService.MESSAGES.CREWING.SCHEDULE_NOT_PUBLISH);
            }
        };

        vm.onShowRegulations = function (params) {
//            var crewScheduleBlock = CrewingHelper.getCrewScheduleBlockId(params && params.block && params.block.events);
            var crewScheduleBlockId = params.block.crewScheduleBlockId;
            var crewProfileId = params.crew.crewDTO.crewProfileId;

            CrewingHelper.getRegulation(crewProfileId, crewScheduleBlockId,
                function (response) {
                    var regulationDetailParam = {
                        regulationMap: response.adaptedRegulationMap,
                        onAcceptPassBackParam: null,
                        hideFooterButtons: true
                    };
                    PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam);
                },
                function (msg) {
                    MessageService.error(msg);
                }
            );
        };

        vm.onShowPaxMsgDet = function (params) {
//          var crewScheduleBlock = CrewingHelper.getCrewScheduleBlockId(params && params.block && params.block.events);
          var crewScheduleBlockId = params.block.crewScheduleBlockId;
          var crewProfileId = params.crew.crewDTO.crewProfileId;

          CrewingHelper.getPaxMessageDet(crewProfileId, crewScheduleBlockId,
              function (response) {
                  var paxParam = {
                      data: response.paxMsgList
                  };
                  PopupManager.openModal('PAX_MSG_DETAILS', paxParam);
              },
              function (msg) {
                  MessageService.error(msg);
              }
          );
      };

        vm.onShowHistory = function (params) {
            var crewProfileId = params.crew.crewDTO.crewProfileId;
            var selectedDate = params.day.date;

            CrewingHelper.getHistory(crewProfileId, selectedDate,
                function (historyResponse) {
                    var param = {
                        history: historyResponse
                    };
                    PopupManager.openModal('HISTORY_DETAILS', param);
                },
                function (msg) {
                    MessageService.error(msg);
                }
            );
        };

        vm.onEditPairing = function(params){
            var _editPairingParams = {
                crewId: params.crew.crewId,
                patternId :  params.block.patternId,
                patternStartDate: !!params.block.patternStartDateZulu ? params.block.patternStartDateZulu : params.block.patternStartDate,
                patternEndDate: !!params.block.patternEndDateZulu ? params.block.patternEndDateZulu : params.block.patternEndDate,
                patternName : params.block.patternName,
                crewBase : params.block.pairingBase,
                requestOrigin : 'crewSchedule'
            };

            var navigateToManagePairing = function(paramToSend){
                setCrewScheduleTabData();
                var tabName = 'managePairing';
                StorageServices.setTabData(tabName,'editPairingParams',paramToSend);
                TabService.gotoTab(tabName, {
                    patternId: paramToSend.patternId
                });
            };

            _editPairingParams.crewBase = angular.isUndefined(_editPairingParams.crewBase) ? applicationConstants.SETTINGS.CREW_BASE_AIRPORT : _editPairingParams.crewBase;
            navigateToManagePairing(_editPairingParams);
        };

        function setCrewScheduleTabData(){
          var _loadCrewScheduleParams = {
            crewId : vm.model.searchDetails.crewID,
            fromDate :vm.model.searchDetails.fromDate,
            toDate : vm.model.searchDetails.toDate
          };

          var tabName = 'crewSchedule';
          StorageServices.setTabData(tabName, 'crewingParams', _loadCrewScheduleParams);
        }

        vm.onNavigateCrewProfile = function(){
            var _loadProfileParams = {
                crewId: vm.model.searchDetails.crewID
            };

            var navigateToCrewProfile = function(paramToSend){
                var tabName = 'crewProfile';
                StorageServices.setTabData(tabName,'loadProfileParams',paramToSend);
                TabService.gotoTab(tabName, {
                    crewId: paramToSend.crewId
                });
            };
            navigateToCrewProfile(_loadProfileParams);
        };

        vm.showingCrewProfilePanel = function (isShowing) {
            $scope.$broadcast('showCrewProfilePanel', isShowing);
        };

        function onFireUndoEvent() {
            CommonMasterData.undoAction(
                function (crewIds) {
                    updateSelectedCrew(crewIds, crewSelect);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function crewSelect() {
            MessageService.success(MessageService.MESSAGES.COMMON.UNDO_SUCCESS);
        }

      vm.openCreditHours = function() {
        var params = {
          crewId : vm.model.crewDTO.crewId,
          fromDate : vm.model.searchDetails.fromDate,
          toDate :vm.model.searchDetails.toDate,
          crewType:vm.model.crewDTO.crewTypeCode,
          tokenId: ApplicationService.getTokenId()
        };

        var details = {};
        CrewingHelper.getCreditHoursDetails(params,
          function(response) {
            details.creditHoursList = response.creditHours;
            PopupManager.openModal('SHOW_CREDIT_HOURS', details, function(){});
          },
          function(error) {
            MessageService.error(error);
          });
      }

      vm.showTrainingStages = function() {
          if(vm.model.trainingStageDetails&&vm.model.trainingStageDetails.crewTrainingStageDTOList.length>0){
            PopupManager.openModal('SHOW_TRAINING_STAGES', vm.model.trainingStageDetails, function(){});
          }
      }

      vm.syncTrainingStages = function() {
        CrewingHelper.syncTrainingStages(
          vm.model.crewDTO.crewProfileId,
          function(response) {
            console.log("response :", response)
            if (response.success) {
              MessageService.success(MessageService.MESSAGES.CREW_SCHEDULE.SYNC_TRAINING_STAGE_SUCCESS);
              if(response.warnings && response.warnings.length > 0){
                MessageService.warning(response.warnings[0]);
              }
              if(response.errors && response.errors.length > 0){
                  MessageService.error(response.errors[0]);
              }
              loadTrainingStages();
              loadActualSchedule(false, undefined, 'Y');
            } else {
              MessageService.error(MessageService.MESSAGES.CREW_SCHEDULE.SYNC_TRAINING_STAGE_FAILED);
            }
          },
          function(error) {
            MessageService.error(error);
          }
        );
      }

      function getHours(min){
        var h = Math.floor(min/60);
        var m = min%60;
        if(m<10){
          m = '0'+m;
        }
        var totalTime = h+'.'+m;
        return totalTime;
      }


    }

    $(window).resize(function(){
    	var height=($("header").height() + $(".tabbed-view-container").height())+"px";
    	$(".CrewSchedule .canvas").css("top", height);
    });
    }());
